<template>
  <v-navigation-drawer v-model="modelValue_" color="amv-yellow">
    <div class="sidebar-header border-gradient d-flex">
      <v-btn icon="mdi-backburger" flat class="ml-1 backburger" @click.stop="modelValue_ = !modelValue_">
      </v-btn>
      <a href="/" class="ml-5">
        <img src="/Logo-eng-web-blue.png" alt="Logo" width="74" height="40" />
      </a>
    </div>
    <v-list>
      <v-list-item prepend-icon="mdi-view-dashboard" title="Dashboard" active-class="active-item" to="/dashboard">
      </v-list-item>
      <v-list-item prepend-icon="mdi-chart-bell-curve" title="Live data" active-class="active-item" to="/analysis/live">
      </v-list-item>
      <v-list-item prepend-icon="mdi-chart-histogram" title="Historic data" active-class="active-item" to="/analysis/historic">
      </v-list-item>
        <v-list-item prepend-icon="mdi-file-chart" title="Report" active-class="active-item" to="/analysis/report">
      </v-list-item>
      <!-- strategy sprout-outline file-tree-outline folder-multiple account-hard-hat -->
      <v-list-item prepend-icon="mdi-folder-multiple" title="Projects" active-class="active-item" to="/projects">
      </v-list-item>
      <v-list-group value="Machines">
        <template v-slot:activator="{ props }">
          <v-list-item v-bind="props" prepend-icon="mdi-excavator" title="Machines"></v-list-item>
        </template>
        <v-list-item prepend-icon="mdi-view-grid" active-class="active-item" to="/machines" title="List"></v-list-item>
        <v-list-item prepend-icon="mdi-file-sign" active-class="active-item" to="/machines/ownership"
          title="Ownership"></v-list-item>
      </v-list-group>
      <v-list-item prepend-icon="mdi-bell" title="Alerts & messages" active-class="active-item" to="/alerts/unread">
      </v-list-item>
      <v-list-group v-if="isAdminViewEnabled" value="Administration">
        <template v-slot:activator="{ props }">
          <v-list-item v-bind="props" prepend-icon="mdi-cog" title="Administration"></v-list-item>
        </template>
        <v-list-item prepend-icon="mdi-card-account-details" active-class="active-item" to="/administration/customers" title="Customers"></v-list-item>
        <v-list-item prepend-icon="mdi-memory" active-class="active-item" to="/administration/devices" title="Devices"></v-list-item>
        <v-list-item prepend-icon="mdi-view-stream" active-class="active-item" to="/administration/hub-message-viewer" title="IoT messages"></v-list-item>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script setup lang="ts">

const { isAdminViewEnabled } = useLayoutOpts();
const { hasPremiumAccess } = useAuth();
const props = defineProps<{
  modelValue: boolean
}>()
const emits = defineEmits<{
  (e: 'update:modelValue', modelValue: boolean): void
}>()

const modelValue_ = computed({
  get: () => props.modelValue,
  set: (val) => emits('update:modelValue', val),
});

</script>

<style scoped lang="scss">
.backburger {
  color: #5c450e;
  background-color: transparent;
}
.active-item {
  color: rgb(var(--v-theme-primary));
}

.sidebar-header {
  overflow: hidden;
  padding: .5rem 0.25rem .5rem 0;
  margin-inline: 0 1.125rem;
  min-block-size: 64px;
  display: flex;
  align-items: center;
}

.border-gradient {
  border: 0 solid;
  border-image-slice: 1;
  border-image-source: linear-gradient(90deg, hsla(0, 0%, 100%, 0), $amv-blue, hsla(0, 0%, 100%, 0));
  border-bottom-width: 1px;
}
</style>